import { Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();

  if (user === null) {
    return (
      <div className="flex h-screen w-full items-center justify-center bg-slate-50" data-testid="auth-loading">
        <Loader2 className="h-6 w-6 animate-spin text-sky-600" />
      </div>
    );
  }
  if (user === false) return <Navigate to="/login" replace />;
  return children;
}
